import { render } from "./CustomerUploadsPage.vue?vue&type=template&id=8040fcc2&scoped=true"
import script from "./CustomerUploadsPage.vue?vue&type=script&lang=js"
export * from "./CustomerUploadsPage.vue?vue&type=script&lang=js"

import "./CustomerUploadsPage.vue?vue&type=style&index=0&id=8040fcc2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8040fcc2"]])

export default __exports__